export const PlusCard = {
  info: [
    "Caja de Ahorro Pesos",
    "Caja de Ahorro Dólares",
    "Tarjeta de Débito Visa Soy Santander",
  ],
  movement: [
    "Extracciones mensuales gratuitas en cajeros Banred (8)",
    "Depósitos por buzoneras sin costo",
    "Transferencias entre cuentas Santander sin costo",
  ],
  coste: ["Costo mensual 120 UI"],
  benefit: [
    "Descuentos y beneficios en todo el país",
    "Canje de Puntos Soy Santander",
    "1 punto = 1 peso",
  ],
};